
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
components: {
Tab,
TabItem
},
methods: {
jump: function (e) {
this.$router.push(e);
}
},
}



// WEBPACK FOOTER //
// ./src/views/Class.vue